import { combineReducers } from '@reduxjs/toolkit';
import app from './appSlice';
import exam from './examSlice';
import chat from './chatSlice';
import inventory from './inventorySlice';
import story from './storySlice';
import feed from './feedSlice';
import vocabGames from './vocabGamesSlice';
import tutorial from './tutorialSlice';
import nav from './navSlice';

const rootReducer = combineReducers({
    app,
    exam,
    chat,
    inventory,
    story,
    feed,
    vocabGames,
    tutorial,
    nav,
});

export default rootReducer;
